<div class="modal-body">
  <h3 *ngIf="title">{{title | translate}}</h3>
  <div *ngIf="body" class="spacer-md" [innerHTML]="body"></div>

  <div class="spacer-sm">
    <kh-input [controlValue]="inputControl" data-testid="input-dialog-input"></kh-input>
  </div>

  <div class="text-center khModalButtons">
      <button class="btn btn-primary" (click)="onFirstButtonClick()" *ngIf="firstButtonText" data-testid="input-dialog-primary-button">{{firstButtonText | translate}}</button>
      <button class="btn btn-default ml-1" (click)="onSecondButtonClick()" *ngIf="secondButtonText" data-testid="input-dialog-secondary-button">{{secondButtonText | translate}}</button>
  </div>
</div>
